export enum JobType {
    DOWNLOAD = '00010',         // Transacciones de descarga
    TRACKING = '00020',         // Rastreo
    RECHARGER = '00040'         // Transacciones de recarga
}